import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles(() => ({
  backdrop: {
    background: 'transparent',
    position: 'absolute',
    zIndex: 100,
  },
}))
